import {combineReducers} from 'redux';

import {makeReducer, match} from 'web-app/util/redux';

import bannerWarnings from './banner-warnings/reducer';
import notificationCenter from './notification-center/reducer';
import notificationCounts, {type NotificationCountsStateType} from './notification-counts/reducer';
import * as Actions from './actions';

const deviceToken = makeReducer<string | null>(
    [
        match(Actions.didReceiveDeviceToken, (state, {payload}) => {
            return payload.deviceToken;
        }),
    ],
    null,
);

export type NotificationState = {
    deviceToken: any;
    bannerWarnings: any;
    notificationCenter: any;
    notificationCounts: NotificationCountsStateType;
};

export default combineReducers<NotificationState>({
    deviceToken,
    bannerWarnings,
    notificationCenter,
    notificationCounts,
});
